import React, { Component } from 'react';
import AmplitudeHelperClass from '../utilities/amplitudeHelper';

const amplitudeHelper = new AmplitudeHelperClass();

class ContentTag extends Component {

    constructor(props) {
        super(props);
    }

    amplitudeTrack = (tag) => {
        amplitudeHelper.trackEvent("news - clicked content tag with type: " + tag);
    }

    render() {

        let allTags  = [];
        let showTags = [];
        let { tagdata, type, displayMax } = this.props;

        if (!tagdata) {
            return null;
        }

        // TODO
        // currently not showing country tag for research (location_id)
        // as it only returns the id not country name

        const contentTags = ["industry_data", "category_data", "news_category_data", "country_data"];
        contentTags.map(x => {
            if (tagdata[x]) {

                // industry
                if ((x == "industry_data") && (tagdata[x][0])) {
                    let industry = tagdata[x][0];
                    if (industry.id) {
                        industry.type = "industry";
                        allTags.push(industry);
                    }
                }

                // research catg
                if ((x == "category_data") && (tagdata[x].id)) {
                    tagdata[x].type = "category";
                    allTags.push(tagdata[x]);
                }

                // news catg
                if (x == "news_category_data") {
                    tagdata[x].map(y => {
                        if (y.id) {
                            y.type = "category";
                            allTags.push(y);
                        }
                    });
                }

                // country
                if ((x == "country_data") && (JSON.stringify(tagdata[x]) != '{}')) {
                    tagdata[x].type = "country";
                    allTags.push(tagdata[x]);
                }

            }
        });

        // trim empty obj, undefined, etc.
        allTags = allTags.filter(value => JSON.stringify(value) !== '{}').filter(Boolean);

        if (!displayMax) {
            displayMax = 3;
        }

        if (allTags.length > 0) {
            allTags.map((y, index) => {
                if (index < displayMax) {
                    showTags.push(
                        <a href={`/${type}?${y.type}=${y.id}`} className="content-tag" key={index + "_" + y.name} onClick={() => this.amplitudeTrack(y.type)}>
                            {y.name}
                        </a>
                    )
                }
            });
            return (
                <div className="content-tag-box" style={this.props.style}>
                    {showTags}
                </div>
            )
        } else {
            return null;
        }
    }

}

export default ContentTag;
